import Context from './context';

class ProductContext extends Context {
  constructor() {
    super();

    this.handleLoad = this.handleLoad.bind(this);
    this.fetchData = this.fetchData.bind(this);
  }

  componentDidMount() {
    globalThis.on('load', this.handleLoad);
    this.handleLoad();
  }

  async handleLoad() {
    await this.fetchData();

    this.setAttribute('data-ready', 'true');
  }

  async fetchData() {
    const res = await fetch(
      `${window.Shopify.routes.root}products/${this.parsedDataset.productHandle}.js`,
    );
    const resJson = await res.json();

    this.set({ product: resJson });

    this.emit('ready', { product: resJson });
  }
}

customElements.define('product-context', ProductContext);
